angular.module('impactx.opengovernmentdata').controller('OpenGovernmentDataAgreementDialogCtrl', [
    'dataGen',
    '$mdDialog',
    OpenGovernmentDataAgreementDialogController]);

function OpenGovernmentDataAgreementDialogController(dataGen, $mdDialog) {
    var self = this;
    self.isLoaded = false;

    dataGen.getData(self, {
        bksIds: self.bksIds,
        prsIds: self.prsIds,
        pohIds: self.pohIds,
        isWarning: self.isWarning
    }, '/opengovernmentdata/report/agreementtext').then(function () {
        self.isLoaded = true;
    });

    self.getLink = function () {
         return "https://www.ris.bka.gv.at/GeltendeFassung.wxe?Abfrage=Bundesnormen&Gesetzesnummer=20010295";
    };

    self.save = function () {
        dataGen.postAsForm(self, {
            bksIds: self.bksIds,
            prsIds: self.prsIds,
            pohIds: self.pohIds,
            isWarning: self.isWarning
        }, '/opengovernmentdata/report/agree').then(function () {
            $mdDialog.hide();
        });
    };

    self.cancel = function () {
        $mdDialog.cancel();
    };

}
